import { PostProjectStatusModel } from "../models/PostProjectStatusModel";
import { EditStatusModel } from "../models/ProjectStatusModel";
import API from "./API";

const ProjectStatusService = {
  async postParticularProjectStatus(projectStatus: PostProjectStatusModel) {
    const response = await API().post(
      "ProjectStatus/PostProjectStatus",
      projectStatus,
      {
        method: "POST",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  },
  async getProjectStatusAdmin() {
    const response = await API().get("ProjectStatus", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data
  },
  async postProjectStatusAdmin(projectStatus: EditStatusModel) {
    const response = await API().post(
      "ProjectStatus/PostProjectStatusAdmin",
      projectStatus,
      {
        method: "POST",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  }
};
export default ProjectStatusService;
